export default __webpack_public_path__ + "6389c6736bd40d0ec3de59ae3404110e.wav";